import React from "react";
import { observer } from "mobx-react";

interface ITableRowProps {
    i: number;
    row: any;
    saveCellValue: Function;
    deleteRow: Function;
}

const TableRow = observer(
    ({ i, row, saveCellValue, deleteRow }: ITableRowProps) => {
        return (
            <tr>
                {row.map((cell: any, j: number) => {
                    return (
                        <td
                            key={`${i}-${j}`}
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            onBlur={ev => saveCellValue(ev, cell, i, j)}
                        >
                            {cell.tableValue}
                        </td>
                    );
                })}
                <td>
                <button
                    onClick={ev => deleteRow(ev, i)}
                    className="table-row-delete btn btn-outline-danger"
                >
                    <i className="fa fa-times" />
                </button>
                </td>
            </tr>
        );
    }
);

export default TableRow;
